"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
class UnreachableCaseError extends Error {
  constructor(value) {
    super(`Unreachable case: ${value}`);
  }
}
exports.UnreachableCaseError = UnreachableCaseError;
function assert(condition) {
  let msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "no additional info provided";
  if (!condition) {
    throw new Error("Assertion Error: " + msg);
  }
}
exports.assert = assert;
function noop() {}
exports.noop = noop;